import { render } from "./pc_report_past_share_component.vue?vue&type=template&id=37703144&scoped=true"
import script from "./pc_report_past_share_component.vue?vue&type=script&scoped=true&lang=js"
export * from "./pc_report_past_share_component.vue?vue&type=script&scoped=true&lang=js"

import "./pc_report_past_share_component.vue?vue&type=style&index=0&id=37703144&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37703144"]])

export default __exports__